import React from 'react';

const Record = () => {
    return (
        <div>
            <h1>records</h1>
        </div>
    );
}

export default Record;
